

<template>
  <div class="ph-detail-content">
    <div class="product-info">
      <div class="product-banner">
        <img :src="detail.m_detail_banner" alt="">
      </div>
      <div class="product-txt">
        <h3>{{ detail.name }}</h3>
        <h4>{{ detail.category ? detail.category.en_name : '' }}</h4>
        <h5>{{ detail.name_content }}</h5>
      </div>
    </div>
    <div class="product-detail-list">
      <div class="product-detail-list">
        <div class="product-detail-item" v-for="item in detail.detail_list">
          <div class="thumb">
            <img :src="item.image" alt="">
          </div>
          <div class="product-detail-item-info">
            <h5>{{ item.name }}</h5>
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-content',
  props:{
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
}

</script>

<style scoped>



.ph-detail-content h1, .ph-detail-content h2, .ph-detail-content h3, .ph-detail-content h4, .ph-detail-content h5 {
  font-family: 'HarmonyOS_Sans_SC_Medium', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
  padding: 0;
  margin: 0;
}
.ph-detail-content p {
  font-family: 'HarmonyOS_Sans_SC_Regular', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  padding: 0;
  margin: 0;
}

.ph-detail-content .product-info {
  width: 100%;
}

.ph-detail-content .product-info .product-txt {

}
.ph-detail-content .product-info .product-txt h3 {
  font-size: 90px;
  font-weight: 500;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 10px;
  line-height: 1.8;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}
.ph-detail-content .product-info .product-txt h4 {
  font-size: 60px;
  font-weight: 500;
  text-align: center;
  padding-bottom: 50px;
  line-height: 1.8;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;

}
.ph-detail-content .product-info .product-txt h5 {
  font-size: 42px;
  text-align: center;
  font-weight: 500;
  line-height: 1.8;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.ph-detail-content .product-info .product-banner,
.ph-detail-content .product-info .product-banner img{
  display: block;
}


.product-detail-list {
  padding: 0 40px;
  margin-top: 53px;
  margin-bottom: 186px;
}
.product-detail-list .product-detail-item {
  margin-top: 186px;
}


.product-detail-list .product-detail-item .thumb,
.product-detail-list .product-detail-item .thumb img {
  display: block;
}
.product-detail-list .product-detail-item .product-detail-item-info {}
.product-detail-list .product-detail-item .product-detail-item-info h5 {
  font-size: 54px;
  font-weight: 500;
  padding: 30px 0 20px 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  line-height: 1.8;
}
.product-detail-list .product-detail-item .product-detail-item-info p {
  font-size: 46px;
  font-weight: 400;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
  line-height: 1.8;
}
</style>
